import React from 'react';
import { Snackbar, Box, IconButton, Paper } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import CheckCircleRoundedIcon from '@material-ui/icons/CheckCircleRounded';
import Error from '@material-ui/icons/Error';
import Warning from '@material-ui/icons/Warning';
import Info from '@material-ui/icons/Info';
import { ToastDialogCleanProps } from 'design-v2/common/ToastDialogClean/types';
import { ToastType } from 'shared-types/SharedTypes';
import { APP_COLORS, Colors } from 'design-v2/globals/colors/colors';

const NS = 'ToastDialogClean';

export default function ToastDialogClean({
  subText,
  warningText,
  message,
  handleClose,
  type = ToastType.success,
  isFullWidth = false,
  anchorOrigin = {
    vertical: 'bottom',
    horizontal: 'right',
  },
  actionText,
  onAction,
}: ToastDialogCleanProps) {
  let Icon;
  let color = '#54C66D';
  switch (type) {
    case ToastType.success:
      Icon = CheckCircleRoundedIcon;
      break;
    case ToastType.error:
      Icon = Error;
      color = '#FF0000';
      break;
    case ToastType.warning:
      Icon = Warning;
      color = '#F18C16';
      break;
    case ToastType.info: // no design for info now
      Icon = Info;
      color = '#2196F3';
      break;
    default:
      break;
  }
  const styleProps = {
    borderRadius: 8,
    width: '100%',
    overflow: 'hidden',
  };
  if (!isFullWidth) {
    // @ts-ignore
    styleProps.maxWidth = 400;
  }
  return (
    <Snackbar style={{ borderRadius: 8 }} open={!!message} anchorOrigin={anchorOrigin} >
      {!!message && (
        <Paper style={styleProps}>
          <Box display="flex" minWidth={400} justifyContent="space-between" alignItems="center">
            <Box
              display="flex"
              alignItems="center"
              style={{
                borderLeft: `8px solid ${color}`,
              }}
            >
              <Box display="flex" mr="12px" ml="12px">
                <Icon style={{ color, width: '32px', height: '32px' }} />
              </Box>
              <Box display="flex" flexDirection="column" style={{ padding: '16px 0' }}>
                <span style={{ fontWeight: 'bold', lineHeight: '24px' }}>{message}</span>
                {subText ? (
                  <span
                    style={{
                      marginTop: '6px',
                      color: '#000000',
                      opacity: 0.5,
                      fontSize: '14px',
                      whiteSpace: 'pre-line',
                    }}
                  >
                    {subText}
                  </span>
                ) : null}
                {warningText ? (
                  <span
                    style={{
                      marginTop: '6px',
                      color: Colors.get(APP_COLORS.clrWarning),
                      fontSize: '12px',
                      whiteSpace: 'pre-line',
                    }}
                  >
                    {warningText}
                  </span>
                ) : null}
              </Box>
            </Box>
            <Box display="flex" alignItems="center">
              {actionText && onAction && (
                <span
                  onClick={onAction}
                  style={{
                    color: '#9C27B0',
                    cursor: 'pointer',
                    fontSize: '14px',
                    fontWeight: 500,
                    padding: '4px 2px',
                  }}
                >
                  {actionText}
                </span>
              )}
              <div style={{ padding: '0 16px' }}>
                <IconButton
                  size="small"
                  aria-label="close"
                  color="inherit"
                  onClick={handleClose}
                  style={{ color: '#c2c2c2' }}
                >
                  <CloseIcon fontSize="default" />
                </IconButton>
              </div>
            </Box>
          </Box>
        </Paper>
      )}
    </Snackbar>
  );
}
